import { IMAGE_LOADER, type ImageLoaderConfig } from '@angular/common';

export const PlaceholderImage = {
  provide: IMAGE_LOADER,
  useValue: (config: ImageLoaderConfig) => {
    return config.src;
  },
};
